import { X } from 'lucide-react';
import React, { useState } from 'react';

const ForceCheckoutOverlay = ({ isOpen, onClose, data }) => {
  const [reason, setReason] = useState('');

  if (!isOpen) return null;

  const handleClose = () => {
    setReason('');
    onClose();
  };

  const handleConfirm = () => {
    if (typeof data?.onConfirm === 'function') {
      data.onConfirm(reason);
    }
    setReason('');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-4 overflow-y-auto">
      <div className="w-full max-w-[464px] h-auto relative bg-neutral-50/50 rounded-xl shadow-[0px_15px_30px_0px_rgba(0,0,0,0.10)] shadow-[0px_5px_20px_0px_rgba(255,255,255,0.10)] shadow-[inset_0px_4px_25px_0px_rgba(255,255,255,0.35)] outline outline-1 outline-offset-[-1px] outline-neutral-300/20 backdrop-blur-[30px] overflow-hidden flex flex-col my-auto">
        <div className="px-6 sm:px-8 pt-4 sm:pt-6 pb-3 sm:pb-4 flex items-start justify-between">
          <h3 className="text-3xl font-semibold text-neutral-900">
            {data?.title || 'Check Out'}
          </h3>
          <button
            type="button"
            onClick={handleClose}
            className="w-6 h-6 rounded-md bg-neutral-300/70 text-neutral-600 hover:bg-neutral-300 inline-flex items-center justify-center"
            aria-label="Close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="px-4 sm:px-6 md:px-8 pb-5">
          <div className="rounded-lg border border-cyan-100 bg-cyan-50/60 p-3">
            <p className="text-xl font-medium text-neutral-900 mb-3">
            {data?.prompt || 'Do you want to force check out?'}
            </p>
            <label className="block text-lg font-medium text-neutral-900 mb-2">
              Reason
            </label>
            <textarea
              value={reason}
              onChange={e => setReason(e.target.value)}
              placeholder="Enter Reason"
              rows={4}
              className="w-full rounded-lg border border-neutral-300 bg-white px-3 py-2 text-sm text-neutral-700 resize-none"
            />

            <div className="mt-4 pt-3 border-t border-gray-200 grid grid-cols-2 gap-3">
              <button
                type="button"
                onClick={handleClose}
                className="rounded-lg bg-red-600 text-white !text-white py-2.5 text-sm font-semibold hover:bg-red-700"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleConfirm}
                className="rounded-lg bg-green-600 text-white !text-white py-2.5 text-sm font-semibold hover:bg-green-700"
              >
                Yes, Check Out
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForceCheckoutOverlay;
